import {
    apiRequest,
    pencantumanGelarList,
    pencantumanGelarActive,
    pencantumanGelarInactive
} from "../../../../../services/adapters/kepegawaian/pencantumanGelarService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", pencantumanGelarList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", pencantumanGelarInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", pencantumanGelarActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository